import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Box, Hidden, InputLabel, CircularProgress, FormControlLabel, Checkbox,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { MyInputImage, MyInputText } from './field';
import {
  MY_FORM_FIELD_TEXT,
  MY_FORM_FIELD_IMAGE,
  MY_FORM_FIELD_DATE,
  MY_FORM_FIELD_TIME,
  MY_FORM_FIELD_SELECT,
  MY_FORM_FIELD_SELECT_MULTIPLE,
  MY_FORM_FIELD_SELECT_AUTOCOMPLETE,
  MY_FORM_FIELD_IMAGE_MULTIPLE,
  MY_FORM_FIELD_HTML,
  MY_FORM_FIELD_COORDINATE,
  MY_FORM_FIELD_CHECKBOX,
} from './form-constants';
import MyFormControl from './field/MyFormControl';
import MyInputDate from './field/MyInputDate';
import MyInputTime from './field/MyInputTime';
import MySelect from './field/MySelect';
import MySelectMultiple from './field/MySelectMultiple';
import MySelectAutocomplete from './field/MySelectAutocomplete';
import MyInputImageMultiple from './field/MyInputImageMultiple';
// eslint-disable-next-line import/no-cycle
import MyInputHTML from './field/html/MyInputHTML';
import pageUtilsPropTypes from '../page/page-prop-types';
import MyInputCoordinate from './field/MyInputCoordinate';

const UncontrolledForm = (props) => {
  const {
    defaultValues,
    fields,
    errors,
    touched,
    handleSubmit,
    disabled,
    isCreate,
    isHideOnMobile,
    useSubmitButton,
    submitLabelId,
    pageUtils,
    repository,
    setValues,
    inputRefs,
    icons,
  } = props;

  return (
    <form
      data-testid="form-data-testid" // Used by MyForm.test.js
      onSubmit={(e) => {
        e.preventDefault();
        const newValues = {};
        fields.map((field) => {
          if (inputRefs[field.name]) {
            if (field.type === MY_FORM_FIELD_TEXT) {
              if (field.inputProps.type === 'currency') {
                const rawValue = inputRefs[field.name].current.attributes['raw-value'];
                if (rawValue) {
                  const val = rawValue.value;
                  if (val) {
                    newValues[field.name] = parseInt(val, 10);
                  } else {
                    newValues[field.name] = '';
                  }
                } else {
                  newValues[field.name] = '';
                }
              } else {
                newValues[field.name] = inputRefs[field.name].current.value;
              }
            } else if (field.type === MY_FORM_FIELD_HTML) {
              newValues[field.name] = inputRefs[field.name].current.getEditorState();
            } else if (field.type === MY_FORM_FIELD_IMAGE) {
              if (inputRefs[field.name].current.files.length > 0) {
                [newValues[field.name]] = inputRefs[field.name].current.files;
              } else {
                newValues[field.name] = defaultValues[field.name];
              }
              newValues[`${field.name}Old`] = defaultValues[field.name];
            } else if (field.type === MY_FORM_FIELD_DATE) {
              let x = inputRefs[field.name].current.value;
              if (x !== '') {
                x = x.split('/');
                newValues[field.name] = new Date(`${x[1]}/${x[0]}/${x[2]}`);
              } else {
                newValues[field.name] = defaultValues[field.name];
              }
            } else if (field.type === MY_FORM_FIELD_TIME) {
              let x = inputRefs[field.name].current.value;
              if (x !== '') {
                x = x.split(':');
                newValues[field.name] = new Date(0, 0, 0, x[0], x[1]);
              } else {
                newValues[field.name] = defaultValues[field.name];
              }
            } else if (field.type === MY_FORM_FIELD_SELECT) {
              newValues[field.name] = inputRefs[field.name].current.value;
            } else if (field.type === MY_FORM_FIELD_SELECT_MULTIPLE) {
              newValues[field.name] = inputRefs[field.name].current.value;
            } else if (field.type === MY_FORM_FIELD_SELECT_AUTOCOMPLETE) {
              newValues[field.name] = inputRefs[field.name].current.value;
            } else if (field.type === MY_FORM_FIELD_IMAGE_MULTIPLE) {
              newValues[field.name] = inputRefs[field.name].current.getValues();
              newValues[`${field.name}Old`] = defaultValues[field.name];
            } else if (field.type === MY_FORM_FIELD_COORDINATE) {
              newValues[field.name] = inputRefs[field.name].current.value;
            } else {
              // TODO handle checkbox
              console.log(field.name);
              console.log(inputRefs[field.name].current.getValues());
            }
          } else {
            newValues[field.name] = defaultValues[field.name];
          }
          return null;
        });
        setValues(newValues);
        setTimeout(() => {
          handleSubmit();
        }, 300);
      }}
    >
      {
        fields.map((field) => {
          if (isCreate && field.isEditOnly) {
            return null;
          }
          let fieldComponent;
          switch (field.type) {
            case MY_FORM_FIELD_TEXT:
              fieldComponent = (
                <MyInputText
                  name={field.name}
                  defaultValue={defaultValues[field.name]}
                  error={touched[field.name] && Boolean(errors[field.name])}
                  inputRef={inputRefs[field.name]}
                  disabled={disabled}

                  autoFocus={field.inputProps.autoFocus}
                  placeholder={field.inputProps.placeholder}
                  type={field.inputProps.type}
                  multiline={field.inputProps.multiline}
                />
              );
              break;
            case MY_FORM_FIELD_SELECT:
              fieldComponent = (
                <MySelect
                  name={field.name}
                  defaultValue={defaultValues[field.name]}
                  inputRef={inputRefs[field.name]}
                  menuItems={field.inputProps.menuItems}

                  autoFocus={field.inputProps.autoFocus}
                  error={touched[field.name] && Boolean(errors[field.name])}
                  disabled={disabled}
                />
              );
              break;
            case MY_FORM_FIELD_SELECT_MULTIPLE:
              fieldComponent = (
                <MySelectMultiple
                  name={field.name}
                  defaultValue={defaultValues[field.name]}
                  inputRef={inputRefs[field.name]}
                  menuItems={field.inputProps.menuItems}

                  autoFocus={field.inputProps.autoFocus}
                  error={touched[field.name] && Boolean(errors[field.name])}
                  disabled={disabled}
                />
              );
              break;
            case MY_FORM_FIELD_SELECT_AUTOCOMPLETE:
              fieldComponent = (
                <MySelectAutocomplete
                  name={field.name}
                  defaultValue={defaultValues[field.name]}
                  inputRef={inputRefs[field.name]}
                  menuItems={field.inputProps.menuItems}

                  autoFocus={field.inputProps.autoFocus}
                  disabled={disabled}
                  error={touched[field.name] && Boolean(errors[field.name])}
                />
              );
              break;
            case MY_FORM_FIELD_IMAGE:
              fieldComponent = (
                <MyInputImage
                  name={field.name}
                  value={defaultValues[field.name]}
                  inputRef={inputRefs[field.name]}

                  autoFocus={field.inputProps.autoFocus}
                  disabled={disabled}
                  error={touched[field.name] && Boolean(errors[field.name])}

                  label={field.label ? field.label : <FormattedMessage id={field.labelId} />}
                  type={field.inputProps.type}
                />
              );
              break;
            case MY_FORM_FIELD_IMAGE_MULTIPLE:
              fieldComponent = (
                <MyInputImageMultiple
                  name={field.name}
                  defaultValues={defaultValues[field.name]}
                  ref={inputRefs[field.name]}

                  autoFocus={field.inputProps.autoFocus}
                  disabled={disabled}
                  error={touched[field.name] && Boolean(errors[field.name])}

                  label={field.label ? field.label : <FormattedMessage id={field.labelId} />}

                  icons={icons}
                />
              );
              break;
            case MY_FORM_FIELD_DATE:
              fieldComponent = (
                <MyInputDate
                  name={field.name}
                  defaultValue={defaultValues[field.name]}
                  inputRef={inputRefs[field.name]}

                  autoFocus={field.inputProps.autoFocus}
                  disabled={disabled}
                  error={touched[field.name] && Boolean(errors[field.name])}
                  required={field.inputProps.required}

                  views={field.inputProps.views}
                />
              );
              break;
            case MY_FORM_FIELD_TIME:
              fieldComponent = (
                <MyInputTime
                  name={field.name}
                  defaultValue={defaultValues[field.name]}
                  inputRef={inputRefs[field.name]}

                  autoFocus={field.inputProps.autoFocus}
                  disabled={disabled}
                  error={touched[field.name] && Boolean(errors[field.name])}
                  required={field.inputProps.required}
                />
              );
              break;
            case MY_FORM_FIELD_HTML:
              fieldComponent = (
                <MyInputHTML
                  name={field.name}
                  editorState={defaultValues[field.name]}
                  inputRef={inputRefs[field.name]}

                  pageUtils={pageUtils}
                  repository={repository}

                  enableImage={field.inputProps.enableImage}

                  disabled={disabled}
                  error={touched[field.name] && Boolean(errors[field.name])}
                />
              );
              break;
            case MY_FORM_FIELD_COORDINATE:
              fieldComponent = (
                <MyInputCoordinate
                  name={field.name}
                  defaultValue={defaultValues[field.name]}
                  inputRef={inputRefs[field.name]}

                  pageUtils={pageUtils}
                  markerLabel={field.inputProps.markerLabel}
                  defaultIsShowMap={field.inputProps.defaultIsShowMap}
                  showMapLabelId={field.inputProps.showMapLabelId}
                  helperTextLabelId={field.inputProps.helperTextLabelId}

                  disabled={disabled}
                />
              );
              break;
            case MY_FORM_FIELD_CHECKBOX:
              fieldComponent = (
                <FormControlLabel
                  control={(
                    <Checkbox
                      name={field.name}
                      defaultValue={defaultValues[field.name]}
                      inputRef={inputRefs[field.name]}

                      disabled={disabled}
                    />)}
                  label={<FormattedMessage id={field.labelId} />}
                />
              );
              break;
            default:
              return null; // unreachable
          }
          return (
            <Box
              key={`form-field-${field.name}`}
            >
              <MyFormControl
                required={field.required}
                error={touched[field.name] && Boolean(errors[field.name])}
                helperText={touched[field.name] ? errors[field.name] : ''}
                fullWidth
              >
                {
                  field.type === MY_FORM_FIELD_CHECKBOX ? null : (
                    <InputLabel shrink htmlFor={field.name}>
                      <FormattedMessage id={field.labelId} />
                    </InputLabel>
                  )
                }
                {fieldComponent}
              </MyFormControl>
            </Box>
          );
        })
      }
      {
        useSubmitButton ? (
          <Hidden xsDown={isHideOnMobile} implementation="css">
            <Box mt={2} align="center">
              <Button
                id="my-form-submit-button"
                type="submit"
                variant="contained"
                color="primary"
                disabled={disabled}
                startIcon={disabled ? <CircularProgress size={20} /> : ''}
              >
                <FormattedMessage id={submitLabelId || 'seed.button.submit'} />
              </Button>
            </Box>
          </Hidden>
        ) : ''
      }
    </form>
  );
};

UncontrolledForm.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,

  handleSubmit: PropTypes.func.isRequired,
  inputRefs: PropTypes.object.isRequired,

  disabled: PropTypes.bool,
  isCreate: PropTypes.bool,
  isHideOnMobile: PropTypes.bool,
  submitLabelId: PropTypes.string,
  pageUtils: pageUtilsPropTypes,
  repository: PropTypes.any,
  useSubmitButton: PropTypes.bool,
};

UncontrolledForm.defaultProps = {
  disabled: false,
  isCreate: true,
  isHideOnMobile: false,
  useSubmitButton: true,
  pageUtils: undefined,
  repository: undefined,
  submitLabelId: 'button.label.submit',
};

export default UncontrolledForm;
